import { render } from "./BlockPreview.vue?vue&type=template&id=f2d9198e"
import script from "./BlockPreview.vue?vue&type=script&lang=js"
export * from "./BlockPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__